import { useMemo } from 'react'

import { RangeValue } from '../types'

interface UseMissedCallCountFilterProps {
  selectedMissedCallCount: RangeValue
  onMissedCallCountChange: (value: RangeValue) => void
}

export const useMissedCallCountFilter = ({
  selectedMissedCallCount,
  onMissedCallCountChange,
}: UseMissedCallCountFilterProps) => {
  const rangeValue = useMemo<RangeValue>(() => {
    return {
      min: 0,
      max: 20,
      gte: selectedMissedCallCount.gte ?? null,
      lte: selectedMissedCallCount.lte ?? null,
    }
  }, [selectedMissedCallCount])

  return {
    rangeValue,
    onChange: onMissedCallCountChange,
    isLoaded: true,
  }
}
